<template>
  <div id="park">
    <header-nav></header-nav>
    <banner-component :banner-data="pageData"></banner-component>
    <div class="content">
      <!-- 左 -->
      <article-side-bar :article-list-nav="pageData"></article-side-bar>      
      <!--右-->
      <div class="content_right">
        <div class="content_header">
          <span class="title">地理位置</span>
          <span class="card">园区概况 > 地理位置</span>
        </div>
        <div class="map">
          <div id="map"></div>
        </div>
        <ul class="contact_info" v-html="details">
        </ul>
      </div>
    </div>
    <partner-list></partner-list>
    <common-footer></common-footer>
  </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import CommonFooter from '@/components/CommonFooter.vue'
  import PartnerList from '@/components/PartnerList.vue'
  import BannerComponent from '@/components/BannerComponent.vue'
  import {queryLocation} from '@/api/Location.js'
  import ArticleSideBar from '@/components/ArticleSideBar.vue'
  export default {
    name: 'Location',
    components: {
      HeaderNav,
      CommonFooter,
      PartnerList,
      BannerComponent,
      ArticleSideBar
    },
    data() {
      return {
        search: '',
        url: '',
        details:''
      }
    },
    computed: {
      pageData: function () {
        let data = this.$store.state.app.static.find((item) => {
          return item.menuId == this.$route.query.menuId
        })
        return data
      },

    },
    created() {},
    mounted: function () {
      this.getMap()
    },
    methods: {
      getMap() {
        queryLocation().then((res) => {
         this.details = res.details
          var map = new BMap.Map('map', {minZoom: 11, maxZoom: 110})
          map.enableScrollWheelZoom(true)
          // 创建地址解析器实例
          var myGeo = new BMap.Geocoder()
          // 将地址解析结果显示在地图上,并调整地图视野
          myGeo.getPoint(res.url, function (point) {
            if (point) {
              map.centerAndZoom(point, 18);
              map.addOverlay(new BMap.Marker(point))
//            console.log(point)
            } else {
              alert("您选择地址没有解析到结果!")
            }
          });
        })
        /*var map = new BMap.Map("map");
        var point = new BMap.Point(116.400244, 39.92556);
        map.centerAndZoom(point, 12);
        var marker = new BMap.Marker(point);  // 创建标注
        map.addOverlay(marker);              // 将标注添加到地图中
        marker.addEventListener("click", getAttr);*/
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
 // $themeColor: #3e76fc;
  #park {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
    .content {
      width: 1200px;
      display: flex;
      margin-bottom: 150px;
      .content_right {
        width: 1112px;
        padding-left: 34px;
        .content_header {
          width: 100%;
          height: 86px;
          border-bottom: 1px solid $themeColor;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 28px;
            color: $themeColor;
          }
          .card {
            font-size: 14px;
            color: #333;
          }
        }
        .map {
          width: 986px;
          height: 440px;
          margin-top: 30px;
          #map {
            width: 100%;
            height: 100%;
          }
        }
        .contact_info {
          margin-top: 30px;
        }
      }
    }
  }
</style>
